export const lawyers = {
  extends: 'Page',
  flow: 'y',
  theme: 'document',

  LawyersData: {
    display: 'none',
    fetch: {
      from: 'lawyers',
      order: { by: 'info_score', asc: false },
      limit: 50,
      cache: '5m',
      // Disabled during text search — SearchData handles OR query instead
      enabled: (el, s) =>
        !s.root.directoryFilter &&
        (s.root.directoryView === 'all' || s.root.directoryView === 'lawyers'),
      params: (el, s) => {
        const root = s.root || s
        const p = {}
        if (root.cityFilter) p.city = root.cityFilter
        if (root.verificationFilter === 'verified') p.is_subscribed = true
        else if (root.verificationFilter === 'unverified')
          p.is_subscribed = { neq: true }
        if (root.statusFilter === 'active') p.status = 'active'
        else if (root.statusFilter === 'inactive') p.status = { neq: 'active' }
        if (root.areaFilter) p.specializations = { contains: [root.areaFilter] }
        return Object.keys(p).length ? p : undefined
      },
      transform: (data, el) => {
        const root = el.state.root || el.state
        if (root && root.directoryFilter) return []
        const lawyers = (data || []).map((item) => el.call('mapLawyer', item))
        if (root && root.update) {
          root.update(
            { lawyers, lawyersLoaded: true, hasMoreLawyers: (data || []).length >= 50 },
            { preventFetch: true }
          )
        }
        return lawyers
      }
    }
  },
  FirmsData: {
    display: 'none',
    fetch: {
      from: 'law_firms',
      order: { by: 'name_en', asc: true },
      limit: 50,
      cache: '5m',
      enabled: (el, s) =>
        !s.root.directoryFilter &&
        (s.root.directoryView === 'all' || s.root.directoryView === 'firms'),
      params: (el, s) => {
        const root = s.root || s
        const p = {}
        if (root.cityFilter) p.city = root.cityFilter
        if (root.verificationFilter === 'verified') p.is_subscribed = true
        else if (root.verificationFilter === 'unverified')
          p.is_subscribed = { neq: true }
        if (root.statusFilter === 'active') p.status = 'active'
        else if (root.statusFilter === 'inactive') p.status = { neq: 'active' }
        if (root.areaFilter) p.practice_areas = { contains: [root.areaFilter] }
        return Object.keys(p).length ? p : undefined
      },
      transform: (data, el) => {
        const root = el.state.root || el.state
        if (root && root.directoryFilter) return []
        const firms = (data || []).map((item) => el.call('mapFirm', item))
        if (root && root.update) {
          root.update(
            { firms, firmsLoaded: true, hasMoreFirms: (data || []).length >= 50 },
            { preventFetch: true }
          )
        }
        return firms
      }
    }
  },
  LawyersCount: {
    display: 'none',
    fetch: {
      method: 'rpc',
      from: 'count_lawyers',
      cache: '10m',
      transform: (data, el) => {
        const root = el.state.root || el.state
        const count = data && data[0] ? data[0].count : 0
        if (root && root.update)
          root.update({ totalLawyers: count }, { preventFetch: true })
      }
    }
  },
  FirmsCount: {
    display: 'none',
    fetch: {
      method: 'rpc',
      from: 'count_firms',
      cache: '10m',
      transform: (data, el) => {
        const root = el.state.root || el.state
        const count = data && data[0] ? data[0].count : 0
        if (root && root.update)
          root.update({ totalFirms: count }, { preventFetch: true })
      }
    }
  },

  // OR-search across name_en + name_ka via direct REST call
  SearchData: {
    display: 'none',
    text: (el, s) => {
      const root = s.root || s
      const q = (root.directoryFilter || '').trim()
      const key =
        q +
        '|' +
        (root.cityFilter || '') +
        '|' +
        (root.verificationFilter || '') +
        '|' +
        (root.statusFilter || '') +
        '|' +
        (root.areaFilter || '')
      if (el.node._lastSearchKey === key) return key
      el.node._lastSearchKey = key
      if (!q) return key
      const version = (el.node._searchVersion = (el.node._searchVersion || 0) + 1)
      el.call('searchDirectory', q, {
        cityFilter: root.cityFilter,
        verificationFilter: root.verificationFilter,
        statusFilter: root.statusFilter,
        areaFilter: root.areaFilter
      }).then(({ lawyers, firms }) => {
        if (el.node._searchVersion !== version) return
        root.update(
          {
            lawyers,
            firms,
            lawyersLoaded: true,
            hasMoreLawyers: false,
            hasMoreFirms: false,
            lawyersVisible: 24
          },
          { preventFetch: true }
        )
      })
      return key
    }
  },

  LandingNav: {},

  // Read ?q= and ?area= from URL on page load
  ParamReader: {
    display: 'none',
    onRender: (el, s) => {
      if (el.node._paramsRead) return
      el.node._paramsRead = true
      const params = new URLSearchParams(window.location.search)
      const q = params.get('q')
      const area = params.get('area')
      const updates = {}
      if (q) updates.directoryFilter = q
      if (area) updates.areaFilter = area
      if (Object.keys(updates).length) s.root.update(updates)
    }
  },

  HeroHeader: {
    tag: 'section',
    flow: 'y',
    align: 'center center',
    textAlign: 'center',
    padding: 'E B B B',
    width: '100%',
    background: 'neutral950',
    color: 'neutral50',
    '@mobileL': { padding: 'D A A A' },

    PageTitle: {
      tag: 'h1',
      text: '{{ lawyersTitle | polyglot }}',
      fontSize: 'E',
      fontWeight: '700',
      color: 'neutral50',
      letterSpacing: '-0.03em'
    },
    PageSubtitle: {
      text: (el, s) => {
        const l = s.root.totalLawyers || (s.root.lawyers || []).length
        const f = s.root.totalFirms || (s.root.firms || []).length
        return l + ' Lawyers \u00B7 ' + f + ' Firms registered in Georgia'
      },
      fontSize: 'A',
      color: 'neutral300',
      marginTop: 'Y'
    },

    SearchBar: {
      flow: 'x',
      align: 'center center',
      gap: 'Y',
      width: '100%',
      maxWidth: 'J',
      margin: 'B -',
      '@mobileL': { flow: 'y' },

      SearchInput: {
        tag: 'input',
        type: 'text',
        placeholder: '{{ searchPlaceholder | polyglot }}',
        flex: '1',
        padding: 'Z A',
        round: 'C',
        theme: 'card',
        fontSize: 'Z',
        outline: 'none',
        transition: 'all 0.2s ease',
        ':focus': { boxShadow: 'black.08 0 Y A' },
        attr: { value: (el, s) => s.root.directoryFilter || '' },
        onRender: (el, s) => {
          if (s.root.directoryFilter && !el.node.value)
            el.node.value = s.root.directoryFilter
        },
        onInput: (e, el, s) => {
          clearTimeout(el.node._searchTimer)
          el.node._searchTimer = setTimeout(() => {
            const q = el.node.value
            // Clear lawyers/firms immediately so stale data doesn't show
            s.root.update({
              directoryFilter: q,
              lawyers: [],
              firms: [],
              lawyersLoaded: false,
              hasMoreLawyers: false,
              hasMoreFirms: false
            })
          }, 400)
        }
      },

      ViewToggle: {
        flow: 'x',
        gap: 'W',
        flexShrink: '0',
        AllBtn: {
          tag: 'button',
          text: '{{ allFilter | polyglot }}',
          padding: 'Z A',
          round: 'C',
          fontSize: 'Z',
          fontWeight: '600',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s ease',
          theme: (el, s) =>
            s.root.directoryView === 'all' ? 'primary' : 'ghost',
          onClick: (e, el, s) => s.root.update({ directoryView: 'all' })
        },
        LawyersBtn: {
          tag: 'button',
          text: '{{ lawyersBtn | polyglot }}',
          padding: 'Z A',
          round: 'C',
          fontSize: 'Z',
          fontWeight: '600',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s ease',
          theme: (el, s) =>
            s.root.directoryView === 'lawyers' ? 'primary' : 'ghost',
          onClick: (e, el, s) => s.root.update({ directoryView: 'lawyers' })
        },
        FirmsBtn: {
          tag: 'button',
          text: '{{ firmsBtn | polyglot }}',
          padding: 'Z A',
          round: 'C',
          fontSize: 'Z',
          fontWeight: '600',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s ease',
          theme: (el, s) =>
            s.root.directoryView === 'firms' ? 'primary' : 'ghost',
          onClick: (e, el, s) => s.root.update({ directoryView: 'firms' })
        }
      }
    },

    FilterRow: {
      flow: 'x',
      gap: 'Y',
      flexWrap: 'wrap',
      align: 'center center',
      maxWidth: 'J',
      children: [
        { label: '{{ allFilter | polyglot }}', value: '' },
        { label: '{{ corporateLaw | polyglot }}', value: 'Corporate Law' },
        { label: '{{ criminalLaw | polyglot }}', value: 'Criminal Law' },
        { label: 'Civil Law', value: 'Civil Law' },
        { label: '{{ familyLaw | polyglot }}', value: 'Family Law' },
        { label: '{{ realEstate | polyglot }}', value: 'Real Estate' },
        { label: '{{ taxLaw | polyglot }}', value: 'Tax Law' },
        { label: '{{ ipLaw | polyglot }}', value: 'IP' },
        { label: '{{ immigration | polyglot }}', value: 'Immigration' },
        { label: '{{ laborLaw | polyglot }}', value: 'Labor Law' },
        {
          label: '{{ bankingFinance | polyglot }}',
          value: 'Banking & Finance'
        },
        { label: 'Administrative', value: 'Administrative Law' },
        { label: 'Constitutional', value: 'Constitutional Law' },
        { label: 'Human Rights', value: 'Human Rights' },
        { label: 'Juvenile Justice', value: 'Juvenile Justice' },
        { label: 'General Practice', value: 'General Practice' }
      ],
      childrenAs: 'state',
      childProps: {
        tag: 'button',
        text: (el, s) => s.label,
        padding: 'Y Z',
        round: 'C',
        fontSize: 'Z',
        fontWeight: '500',
        cursor: 'pointer',
        border: 'none',
        whiteSpace: 'nowrap',
        transition: 'all 0.2s ease',
        theme: (el, s) =>
          (s.root.areaFilter || '') === s.value ? 'primary' : 'ghost',
        onClick: (e, el, s) => s.root.update({ areaFilter: s.value })
      }
    },

    FilterSelects: {
      flow: 'x',
      gap: 'Z',
      flexWrap: 'wrap',
      align: 'center center',
      maxWidth: 'J',
      margin: 'A - -',

      CitySelect: {
        tag: 'select',
        padding: 'Y Z',
        round: 'Z',
        fontSize: 'Z',
        fontWeight: '500',
        cursor: 'pointer',
        background: 'transparent',
        color: 'neutral300',
        border: '1px solid neutral700',
        outline: 'none',
        onRender: (el, s) => {
          el.node.value = s.root.cityFilter || ''
        },
        onChange: (e, el, s) => s.root.update({ cityFilter: el.node.value }),
        children: [
          { label: 'All Cities', val: '' },
          { label: 'Tbilisi', val: 'Tbilisi' },
          { label: 'Batumi', val: 'Batumi' },
          { label: 'Kutaisi', val: 'Kutaisi' },
          { label: 'Rustavi', val: 'Rustavi' },
          { label: 'Zugdidi', val: 'Zugdidi' },
          { label: 'Gori', val: 'Gori' },
          { label: 'Telavi', val: 'Telavi' },
          { label: 'Ozurgeti', val: 'Ozurgeti' },
          { label: 'Akhaltsikhe', val: 'Akhaltsikhe' },
          { label: 'Senaki', val: 'Senaki' }
        ],
        childrenAs: 'state',
        childProps: {
          tag: 'option',
          text: (el, s) => s.label,
          attr: { value: (el, s) => s.val }
        }
      },

      VerificationSelect: {
        tag: 'select',
        padding: 'Y Z',
        round: 'Z',
        fontSize: 'Z',
        fontWeight: '500',
        cursor: 'pointer',
        background: 'transparent',
        color: 'neutral300',
        border: '1px solid neutral700',
        outline: 'none',
        onRender: (el, s) => {
          el.node.value = s.root.verificationFilter || ''
        },
        onChange: (e, el, s) =>
          s.root.update({ verificationFilter: el.node.value }),
        children: [
          { label: 'All Verification', val: '' },
          { label: 'Verified', val: 'verified' },
          { label: 'Unverified', val: 'unverified' }
        ],
        childrenAs: 'state',
        childProps: {
          tag: 'option',
          text: (el, s) => s.label,
          attr: { value: (el, s) => s.val }
        }
      },

      StatusSelect: {
        tag: 'select',
        padding: 'Y Z',
        round: 'Z',
        fontSize: 'Z',
        fontWeight: '500',
        cursor: 'pointer',
        background: 'transparent',
        color: 'neutral300',
        border: '1px solid neutral700',
        outline: 'none',
        onRender: (el, s) => {
          el.node.value = s.root.statusFilter || ''
        },
        onChange: (e, el, s) => s.root.update({ statusFilter: el.node.value }),
        children: [
          { label: 'All Status', val: '' },
          { label: 'Active', val: 'active' },
          { label: 'Inactive', val: 'inactive' }
        ],
        childrenAs: 'state',
        childProps: {
          tag: 'option',
          text: (el, s) => s.label,
          attr: { value: (el, s) => s.val }
        }
      }
    },

    ResultCount: {
      text: (el, s) => {
        const q = s.root.directoryFilter
        if (!q) return ''
        if (!s.root.lawyersLoaded) return '...'
        const view = s.root.directoryView
        const n =
          view === 'firms'
            ? (s.root.firms || []).length
            : (s.root.lawyers || []).length
        const key = view === 'firms' ? 'firmsMatch' : 'lawyersMatch'
        return n + ' {{ ' + key + ' | polyglot }} "' + q + '"'
      },
      opacity: '0.5',
      margin: 'A2 -'
    }
  },

  ContentLayout: {
    width: '100%',
    maxWidth: 'K',
    margin: '0 auto',
    padding: 'B B',
    '@mobileL': { padding: 'A' },

    DirectoryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      '@tabletS': { gridTemplateColumns: 'repeat(2, 1fr)' },
      '@mobileL': { gridTemplateColumns: '1fr' },
      gap: 'B',
      children: (el, s) => {
        const view = s.root.directoryView || 'all'
        const visible = s.root.lawyersVisible || 24
        // Backend handles all filtering (search, city, verification, status, area)
        let results = []
        if (view === 'all' || view === 'lawyers')
          results = results.concat(
            (s.root.lawyers || []).map((l) => ({ ...l, _type: 'lawyer' }))
          )
        if (view === 'all' || view === 'firms')
          results = results.concat(
            (s.root.firms || []).map((f) => ({ ...f, _type: 'firm' }))
          )
        return results.slice(0, visible)
      },
      childrenAs: 'state',
      childExtends: 'DirectoryCard'
    },

    ShowMoreBtn: {
      tag: 'button',
      show: (el, s) => {
        const visible = s.root.lawyersVisible || 24
        const loaded =
          (s.root.lawyers || []).length + (s.root.firms || []).length
        return visible < loaded || s.root.hasMoreLawyers || s.root.hasMoreFirms
      },
      text: (el, s) => {
        const visible = s.root.lawyersVisible || 24
        const loaded =
          (s.root.lawyers || []).length + (s.root.firms || []).length
        const hasFilters =
          s.root.cityFilter ||
          s.root.verificationFilter ||
          s.root.statusFilter ||
          s.root.directoryFilter ||
          s.root.areaFilter
        const hasMore = s.root.hasMoreLawyers || s.root.hasMoreFirms
        const total = hasFilters
          ? loaded + (hasMore ? '+' : '')
          : (s.root.totalLawyers || 0) + (s.root.totalFirms || 0) || loaded
        return '{{ loadingMore | polyglot }} (' + visible + ' / ' + total + ')'
      },
      theme: 'ghost',
      padding: 'Z1 C',
      round: 'Z',
      fontSize: 'A',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'block',
      textAlign: 'center',
      width: '100%',
      maxWidth: 'H',
      margin: 'C auto',
      transition: 'all 0.2s ease',
      ':hover': { theme: 'primary' },
      onClick: (e, el, s) => {
        const current = s.root.lawyersVisible || 24
        const loaded =
          (s.root.lawyers || []).length + (s.root.firms || []).length
        const next = current + 24
        s.root.update({ lawyersVisible: next })
        // Fetch next page from backend when approaching end of loaded data
        if (next >= loaded) {
          const page = el.parent?.parent
          if (page) {
            const ld = page.LawyersData
            if (ld && ld.__ref && ld.__ref.__hasNextPage)
              ld.__ref.fetchNextPage()
            const fd = page.FirmsData
            if (fd && fd.__ref && fd.__ref.__hasNextPage)
              fd.__ref.fetchNextPage()
          }
        }
      }
    }
  },

  FooterSection: {
    tag: 'footer',
    flow: 'y',
    gap: 'C',
    padding: 'D 0',
    borderTop: '1px solid surfaceBorderStrong',
    maxWidth: 'K',
    margin: '0 auto',
    width: '100%',
    '@mobileL': { padding: 'C A' },

    FooterTop: {
      flow: 'x',
      gap: 'C',
      '@mobileL': { flow: 'y', gap: 'B' },
      FooterBrand: {
        flow: 'y',
        gap: 'A',
        flex: '1.5',
        minWidth: 'F',
        FooterLogo: {
          extends: 'Link',
          href: '/',
          text: 'TrustLegal',
          fontSize: 'B',
          fontWeight: '800',
          color: 'green',
          textDecoration: 'none'
        },
        FooterTagline: {
          text: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 SaaS \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0.',
          fontSize: 'Z',
          color: 'textMuted',
          lineHeight: '1.6'
        }
      },
      FooterLinks: {
        flow: 'x',
        gap: 'C',
        flex: '2',
        '@mobileL': { flow: 'y', gap: 'B' },
        FooterCol1: {
          flow: 'y',
          gap: 'Z',
          flex: '1',
          ColTitle: {
            text: '\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'textMuted',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            padding: '0 0 Z 0'
          },
          ColLink1: {
            extends: 'Link',
            href: '/bookings',
            text: '\u10EF\u10D0\u10D5\u10E8\u10D0\u10DC\u10D8',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': { color: 'text' },
            onClick: (e, el, s) => s.root.update({ loggedIn: true })
          },
          ColLink2: {
            extends: 'Link',
            href: '/cases',
            text: '\u10E1\u10D0\u10E5\u10DB\u10D4\u10D4\u10D1\u10D8',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': { color: 'text' },
            onClick: (e, el, s) => s.root.update({ loggedIn: true })
          },
          ColLink3: {
            extends: 'Link',
            href: '/documents',
            text: 'AI \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': { color: 'text' },
            onClick: (e, el, s) => s.root.update({ loggedIn: true })
          },
          ColLink4: {
            extends: 'Link',
            href: '/lawyers',
            text: '{{ lawyersNav | polyglot }}',
            fontSize: 'Z',
            color: 'green',
            textDecoration: 'none',
            fontWeight: '500'
          }
        },
        FooterCol2: {
          flow: 'y',
          gap: 'Z',
          flex: '1',
          ColTitle: {
            text: '\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0',
            fontSize: 'Y',
            fontWeight: '600',
            color: 'textMuted',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            padding: '0 0 Z 0'
          },
          ColLink1: {
            extends: 'Link',
            href: '/',
            text: '\u10E9\u10D5\u10D4\u10DC\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': { color: 'text' }
          },
          ColLink2: {
            extends: 'Link',
            href: '/',
            text: '\u10D9\u10D0\u10E0\u10D8\u10D4\u10E0\u10D0',
            fontSize: 'Z',
            color: 'textMuted',
            textDecoration: 'none',
            ':hover': { color: 'text' }
          }
        }
      }
    },
    FooterBottom: {
      flow: 'x',
      align: 'center space-between',
      padding: 'A 0 0 0',
      borderTop: '1px solid surfaceBorderStrong',
      '@mobileL': { flow: 'y', gap: 'Z', align: 'center center' },
      CopyText: {
        text: '\u00A9 2026 TrustLegal',
        fontSize: 'Z',
        color: 'textMuted'
      },
      BuiltWith: {
        text: 'Built with Symbols',
        fontSize: 'Z',
        color: 'textMuted'
      }
    }
  }
}
